import { gql } from "@apollo/client";

export const GET_CARRIER_OPTIONS = gql`
    query GetCarrierOptions($includeSwiftX: Boolean!) {
        getCarrierOptions(includeSwiftX: $includeSwiftX) {
            value
            name
        }
    }
`;

export interface CarrierOption {
    value: number;
    name: string;
}

export interface GetCarrierOptionsResponse {
    getCarrierOptions: CarrierOption[];
}
